import React from "react";
import Button from "./Button";

const PageBannerTwo = ({ image, heading, button }) => {
  return (
    <section
      className="page-banner bg_cover position-relative z-1"
      style={{ backgroundImage: `url(${image?.asset?.url})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-title">
              <h2>{heading}</h2>
            </div>
            {button?.title && (
              <div className="mt-20">
                <Button
                  text={button.title}
                  btnType={button.btnType}
                  link={button.link}
                  linkType={button.linkType}
                  border="bordered-black"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default PageBannerTwo;
